module.exports = __webpack_public_path__ + "img/800edc1.png";